import React from "react";
import { Checkbox, Typography } from "@material-ui/core";

import Placeholder from "components/Placeholder";
import { useUsers, useNotifications } from "hooks";
import UserPresenter from "presenters/UserPresenter";

import SectionHeader from "../SectionHeader";

import useStyles from "./useStyles";

const EmailPreferences = () => {
  const classes = useStyles();
  const { currentUser, updateUser } = useUsers();
  const { addSuccessNotification } = useNotifications();

  const handleChange = (event) => {
    const params = {
      data: {
        type: "users",
        attributes: {
          "preference-email": event.target.checked,
        },
      },
    };

    return updateUser(params).then((user) => {
      let successMessage = "You've successfully ";
      successMessage += UserPresenter.preferenceEmail(user) ? "subscribed!" : "unsubscribed!";
      addSuccessNotification(successMessage);
    });
  };

  return (
    <div className={classes.root}>
      <SectionHeader>Email Preferences</SectionHeader>

      {!currentUser && <Placeholder variant="text" />}

      {currentUser && (
        <div className={classes.row}>
          <Checkbox
            checked={UserPresenter.preferenceEmail(currentUser)}
            onChange={handleChange}
            name="emailPref"
            color="primary"
          />

          <Typography className={classes.description}>
            Please send me fun JibJab emails about new content, apps, and upcoming holidays
          </Typography>
        </div>
      )}
    </div>
  );
};

export default EmailPreferences;
